import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Utilities } from '../utilities';

export class Errors {
  public static isUnauthorized(error: unknown): boolean {

    if (error instanceof HttpErrorResponse) {
      return error.status == HttpStatusCode.Unauthorized;
    }

    if (error instanceof Error) {
      return error.stack && error.stack.indexOf("Status code '401'") > -1;
    }

    return false;
  }

  public static toError(error: unknown): Error {
    if (Utilities.isNullOrUndefined(error)) {
      return new Error("Неопределенная ошибка.");
    }

    if (error instanceof Error) {
      return error;
    }

    return new Error(`${error.constructor.name}: '${JSON.stringify(error)}'`);
  }
}
